import { Component, AfterViewInit, ViewChildren, OnInit, QueryList, Inject, ElementRef } from '@angular/core';
import { QuestionType } from "../../service/constants";
import { WeeklyquizComponent } from './weekly-quiz/weeklyquiz.component';
import { Behaviour } from 'src/app/model/Behaviour.model';
import { UserRepository } from "src/app/model/user.repository";
import { Router } from '@angular/router';
import { SharedExperiencePoint, SHARED_XP } from './sharedstate.model';
import {  Observable } from 'rxjs';
import { ValueStoreService } from 'src/app/service/value-store.service';

@Component({
  selector: 'app-weekly-quiz-wrapper',
  templateUrl: './weekly-quiz-wrapper.component.html',
  styleUrls: ['./weekly-quiz-wrapper.component.css']
})
export class WeeklyQuizWrapperComponent implements AfterViewInit, OnInit {

  // @ViewChildren(WeeklyquizComponent) weeklyQuizzes: [];
  @ViewChildren(WeeklyquizComponent) weeklyQuizzes!: QueryList<WeeklyquizComponent>;
  public localQuestionType: any;
  private quizIndex: number = 0;
  public isCompleted: boolean = false;
  public experiencePoint: number = 0;
  public quizInstance: any;

  constructor(private userRepository: UserRepository, private router: Router,
    private elementRef: ElementRef,
   @Inject(SHARED_XP) public subjectStateEvent: Observable<SharedExperiencePoint>,
   private valueStoreService: ValueStoreService
  ) { }

  ngOnInit(): void {
    this.localQuestionType = QuestionType;
    this.subjectStateEvent.subscribe((update) => {
        if (update.isReset) {
          this.experiencePoint = 0;
        } else {
          console.log("Adding XP Point"+ update.experiencePoint);
          this.experiencePoint += update.experiencePoint;
        }
    });
  }

  ngAfterViewInit(): void {
    console.log("Total WeeklyQuiz instances:", this.weeklyQuizzes.length);
  }

  next() {

    let behaviour: Behaviour = new Behaviour();
    behaviour.description = "User is clicking next button from Weekly Quiz Wrapper page";
    this.userRepository.trackUserBehaviour(behaviour);

    this.scrollQuestionIntoView("myQuestionCard", 100);

    const firstQuizInstance = this.weeklyQuizzes.first;
    this.quizIndex++;
    this.weeklyQuizzes.forEach( (quizInstance: WeeklyquizComponent)=> {
      quizInstance.nextQuiz(this.quizIndex);
    })

    if (this.quizIndex >= firstQuizInstance.getNumExistingSubject()) {
      this.isCompleted = true;
      this.quizInstance=firstQuizInstance;
    }

  }

  restart() {

    let behaviour: Behaviour = new Behaviour();
    behaviour.description = "User is clicking restart button from Weekly Quiz Wrapper page";
    this.userRepository.trackUserBehaviour(behaviour);

    this.quizIndex = 0;
    this.isCompleted = false;
    this.weeklyQuizzes.forEach( (quizInstance: WeeklyquizComponent)=> {
        quizInstance.nextQuiz(this.quizIndex);
        quizInstance.resetXP();
      })

      if (this.quizInstance != null) {
        this.quizInstance.resetXP();
      } else {
        const firstQuizInstance = this.weeklyQuizzes.first;
        firstQuizInstance.resetXP();
      }

  }

  /**
   * * Scrolls the question panel into view to ensure the user
   * does not need to manually scroll up or down to see the current question.
   * @param elementId - id name of main question panel div element
   * @param offSet
   */
   scrollQuestionIntoView(elementId: string, offSet: number): void {
    const targetEl = this.elementRef.nativeElement.ownerDocument.getElementById(elementId);
        if (targetEl) {
          const offsetTop = (targetEl.getBoundingClientRect().top + window.pageYOffset) - offSet;
          this.elementRef.nativeElement.ownerDocument.defaultView.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
  }

  navigateToSignUp(position: string) {

    let behaviour: Behaviour = new Behaviour();
    behaviour.description = "User is clicking Sign up button from "+position+" landing/store comp page";
    this.userRepository.trackUserBehaviour(behaviour);

    this.router.navigate(['registration']);
 }


 navigateToMyAccount(position: string) {

  let behaviour: Behaviour = new Behaviour();
  behaviour.description = "User is clicking my-account button from "+position+" landing/store comp page";
  this.userRepository.trackUserBehaviour(behaviour);

  this.router.navigate(['myaccount']);
}


}
